import request from '@/axios'
import type { UserType } from './types'

interface RoleParams {
  roleName: string
}

export const genCaptchaApi =  (data: {sceneType: string, phone: string}): Promise<any> => {
  return request.post({ url: '/users/captcha', data })
}

export const registerApi = (data: {loginId: string, password: string,  phone:string, captcha:string}): Promise<any> => {
  return request.post({ url: '/users/register', data })
}

export const updateUserInfoApi = (data: any): Promise<any> => {
  return request.put({ url: '/users/user-info', data })
}

export const updateUserAvatarApi = (data: any): Promise<any> => {
  return request.put({ url: '/users/user-avatar', data })
}

export const updatePasswordApi = (data : { password:string, newPassword:string }): Promise<any> => {
  return request.put({ url: '/users/password', data })
}

export const wxLoginApi = ( params : any): Promise<any> => {
  return request.get({ url: '/users/oauth/token', params })
}

export const apLoginApi = (params: any): Promise<any> => {
  return request.get({ url: '/users/token', params })
}

export const captchaLoginApi = (params: any): Promise<any> => {
  return request.get({ url: '/users/token', params: {...params, grantType:'captcha'} })
}

export const loginApi = (data: UserType): Promise<UserType> => {
  return request.get({ url: '/mock/users/authorize', data })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/mock/user/loginOut' })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<AppCustomRouteRecordRaw[]> => {
  return request.get({ url: '/mock/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<string[]> => {
  return request.get({ url: '/mock/role/list2', params })
}

export const getPermissionsApi = (): Promise<AppPermissionRecordRaw[]> => {
  return request.get({ url: '/users/permission' })
}
